class StoreGallery extends HTMLElement {
  connectedCallback() {
    this.slides = this.querySelectorAll('[data-slide-index]');
    this.thumbs = this.querySelectorAll('[data-thumb-index]');
    this.currentIndex = 0;
    this.total = parseInt(this.dataset.total, 10) || 1;

    if (this.total <= 1) return;

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const thumb = event.target.closest('[data-thumb-index]');
    if (thumb) {
      this.goTo(parseInt(thumb.dataset.thumbIndex, 10));
      return;
    }

    const prev = event.target.closest('[data-action="prev"]');
    if (prev) {
      this.goTo((this.currentIndex - 1 + this.total) % this.total);
      return;
    }

    const next = event.target.closest('[data-action="next"]');
    if (next) {
      this.goTo((this.currentIndex + 1) % this.total);
    }
  }

  goTo(index) {
    if (index === this.currentIndex) return;

    this.slides[this.currentIndex].classList.remove(
      'section-store-details__gallery-slide--active'
    );
    if (this.thumbs[this.currentIndex]) {
      this.thumbs[this.currentIndex].classList.remove(
        'section-store-details__gallery-thumb--active'
      );
    }

    this.currentIndex = index;

    this.slides[this.currentIndex].classList.add(
      'section-store-details__gallery-slide--active'
    );
    if (this.thumbs[this.currentIndex]) {
      this.thumbs[this.currentIndex].classList.add(
        'section-store-details__gallery-thumb--active'
      );
    }
  }
}

customElements.define('store-gallery', StoreGallery);
